import React from 'react';
type props = {
  Label: string;
  labelClass?: string;
  value: any;
  setValue: (data: any) => void;
  Error?: boolean;
  ErrorMessage?: string;
  disabled?: boolean;
  children: React.ReactNode;
  dataTestId?: string;
};

const DropDown: React.FunctionComponent<props> = ({
  Label,
  labelClass,
  value,
  setValue,
  children,
  disabled,
  dataTestId,
}): JSX.Element => {
  return (
    <div>
      {Label.length > 0 && (
        <label className={`${labelClass ? labelClass : 'text-gray-dark mb-2 block leading-4'} `}>{Label}</label>
      )}
      <div className="relative mb-2 inline-flex w-full" data-testid={dataTestId}>
        <svg
          className="pointer-events-none absolute right-0 top-0 mr-3 mt-3 h-2 w-2"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 412 232"
        >
          <path
            d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
            fill="#648299"
            fill-rule="nonzero"
          />
        </svg>
        <select
          className="text-gray-dark bg-gray-background-light h-full w-full appearance-none rounded-md px-5 py-2 text-sm font-extrabold leading-4 focus:ring-transparent"
          onChange={(e: any) => {
            setValue(e.target.value);
          }}
          value={value}
          disabled={disabled}
        >
          {children}
        </select>
      </div>
    </div>
  );
};

export default DropDown;
